import { useState } from "react"

import { cn } from "@f2e/ui/lib/utils"

import { PageNav } from "@/components"

export interface PageProviderProps<T> {
  className?: string
  data: T[]
  defaultPage?: number
  totalPages: number
  renderItem?: (item: T, idx: number) => React.ReactNode
  onPageChange?: (page: number) => void
}

const PageProvider = <T,>({
  className,
  data,
  defaultPage = 1,
  totalPages,
  renderItem,
  onPageChange,
}: PageProviderProps<T>) => {
  const [page, setPage] = useState<number>(defaultPage)

  const handlePageChange = (page: number) => {
    setPage(page)
    onPageChange?.(page)
  }

  return (
    <>
      <div className={cn("flex flex-col gap-4", className)}>
        {data.map((item, idx) => renderItem?.(item, idx))}
      </div>
      <PageNav
        className="mt-12"
        page={page}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </>
  )
}

export default PageProvider
